import { environment } from '@coin/shared/core/util-environments';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LegacyHealthCheckService {
  private httpClient = inject(HttpClient);

  ping(): Observable<void> {
    const isInMaintenance = false;
    if (isInMaintenance) {
      return throwError(null);
    }
    return this.httpClient.get<void>(`${environment.api.baseUrl}/healthcheck`);
  }
}
